import { styled } from 'styled-components';
export const HelpBlock = styled.span `
  font-size: 12px;
  color: ${({ hint, theme }) => (hint ? theme.colors.grey70_1 : theme.colors.critical100)};
  display: block;
  margin-top: 5px;
`;
